import React, { useContext, useState } from 'react';
import { Outlet, Link, useNavigate } from 'react-router-dom';
import { AppBar, Toolbar, Typography, Button, Box, IconButton, Menu, MenuItem, Avatar, Badge, Drawer } from '@mui/material';
import { Menu as MenuIcon, Notifications as NotificationsIcon, AccountCircle, ChevronRight, ArrowDropDown } from '@mui/icons-material';
import AuthContext from '../context/AuthContext';
import NotificationContext from '../context/NotificationContext';
import Footer from '../components/common/Footer';
import Header from '../components/common/Header';

const MainLayout = (props) => {
    const { isAuthenticated, currentUser, userRole, logout } = useContext(AuthContext);
    // const { notifications, unreadCount, markAsRead } = useContext(NotificationContext);
    const navigate = useNavigate();

    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [notificationEl, setNotificationEl] = useState(null);

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleNotificationOpen = (event) => {
        setNotificationEl(event.currentTarget);
    };

    const handleNotificationClose = () => {
        setNotificationEl(null);
    };

    const handleNotificationClick = (notificationId) => {
        // markAsRead(notificationId);
        // Handle navigation based on notification type
        handleNotificationClose();
    };

    const handleLogout = () => {
        logout();
        navigate('/');
        handleMenuClose();
    };

    const navigateToDashboard = () => {
        handleMenuClose();

        switch (userRole) {
            case 'jobseeker':
                navigate('/jobseeker');
                break;
            case 'recruiter':
                navigate('/recruiter');
                break;
            case 'admin':
                navigate('/admin');
                break;
            default:
                navigate('/');
        }
    };

    const toggleMobileMenu = () => {
        setMobileMenuOpen(!mobileMenuOpen);
    };

    return (
        <div className="flex flex-col min-h-screen">
            <Header />
                <div className='bg-gray-100 py-4'>
                    {props.children}
                </div>
            <Footer />

            {/* <AppBar position="sticky" className="bg-white text-neutral-darkest shadow-nav">
                <Toolbar className="justify-between">
                    <Link to="/" className="no-underline">
                        <Typography variant="h6" component="div" className="font-heading font-bold text-primary">
                            Talexo
                        </Typography>
                    </Link>

                    <Box className="hidden md:flex items-center space-x-4">
                        <Button component={Link} to="/jobs" color="inherit">
                            Find Jobs
                        </Button>
                        <Button component={Link} to="/companies" color="inherit">
                            Companies
                        </Button>

                        {isAuthenticated && (
                            <>
                                <IconButton
                                    color="inherit"
                                    onClick={handleNotificationOpen}
                                >
                                    <Badge badgeContent={unreadCount} color="error">
                                        <NotificationsIcon />
                                    </Badge>
                                </IconButton>
                                <Menu
                                    anchorEl={notificationEl}
                                    open={Boolean(notificationEl)}
                                    onClose={handleNotificationClose}
                                    className="mt-2"
                                >
                                    <div className="w-72 max-h-96 overflow-auto">
                                        <Typography className="p-2 font-semibold border-b">Notifications</Typography>

                                        {notifications.length === 0 ? (
                                            <Typography className="p-4 text-center text-gray-500">No notifications</Typography>
                                        ) : (
                                            notifications.map((notification) => (
                                                <MenuItem
                                                    key={notification.id}
                                                    onClick={() => handleNotificationClick(notification.id)}
                                                    className={`border-b ${!notification.read ? 'bg-blue-50' : ''}`}
                                                >
                                                    <div className="py-1">
                                                        <Typography variant="body2" className="font-medium">
                                                            {notification.title}
                                                        </Typography>
                                                        <Typography variant="caption" className="text-gray-500">
                                                            {notification.message}
                                                        </Typography>
                                                    </div>
                                                </MenuItem>
                                            ))
                                        )}

                                        {notifications.length > 0 && (
                                            <MenuItem
                                                component={Link}
                                                to={`/${userRole}/notifications`}
                                                className="justify-center text-primary"
                                            >
                                                View All
                                            </MenuItem>
                                        )}
                                    </div>
                                </Menu>

                                <Button
                                    onClick={handleMenuOpen}
                                    color="inherit"
                                    endIcon={<ArrowDropDown />}
                                    className="ml-2"
                                >
                                    {currentUser?.name ? (
                                        <span>{currentUser.name.split(' ')[0]}</span>
                                    ) : (
                                        <AccountCircle />
                                    )}
                                </Button>
                                <Menu
                                    anchorEl={anchorEl}
                                    open={Boolean(anchorEl)}
                                    onClose={handleMenuClose}
                                >
                                    <MenuItem onClick={navigateToDashboard}>Dashboard</MenuItem>
                                    <MenuItem
                                        onClick={() => {
                                            handleMenuClose();
                                            navigate(`/${userRole}/profile`);
                                        }}
                                    >
                                        My Profile
                                    </MenuItem>
                                </Menu>
                            </>
                        )}
                    </Box>
                </Toolbar>
            </AppBar> */}
        </div>
    )
}

export default MainLayout;